// angular
import { Component, Input, OnDestroy, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

// others
import { AppService } from '../../../../app.service';
import { AuthService } from '../../../../core/auth.service';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { DefaultCardComponent } from '../default-card.component';
import { ProfileService } from '../../../profile/profile.service';
import { CoreService } from '../../../../core/core.service';
import { concatMap, from, tap } from 'rxjs';

@Component({
    selector: 'diga-card',
    templateUrl: './diga-card.component.html',
    styleUrls: ['./diga-card.component.scss']
})

export class DigaCardComponent extends DefaultCardComponent implements OnInit {
    data: any;
    submitted: boolean;
    checked: boolean = false;
    articles = [];

    @Input() callApi = true;
    @Input() blockData = false;
    @Input() profile: any;
    @Input() slug: string;
    @Input() srStep: number;
    @Input() patientStep: number;
    @Output() updateUI = new EventEmitter();

    constructor(
        public appService: AppService,
        public fb: FormBuilder,
        public translate: TranslateService,
        public coreService: CoreService,
        public router: Router,
        public profileService: ProfileService,
        public authService: AuthService
    ) {
        super(appService, fb, translate, coreService, router, profileService, authService);
    }

    ngOnInit() {
        // this.url = this.url + '/' + this.storyBlock;
        if (this.callApi) {
            this.url = this.url + '/' + this.slug;
            this.getContent();
            this.translate.onLangChange.subscribe(value => {
                this.getContent();
            });
        } else {
            this.data = this.blockData['content'];
        }
    }

    getContent() {
        this.articles = [];
        this.appService.getStoryBlokDataForClinic(this.url).subscribe(res => {
            this.data = res['story']['content'] ?? [];
            if(this.data && this.data.articles){
                from(this.data.articles).pipe(
                    tap(() => {
                        this.appService.isLoading = true;
                    }),
                    concatMap(
                        step => this.appService.getStoryBlokSlugByUuid(step)
                    ),
                ).subscribe(response => {
                        this.articles.push(response['story']);
                    },
                    () => {
                    },
                    () => {
                        this.appService.isLoading = false;
                    });
            }
            this.appService.isLoading = false;
        });
    }

    /**
     * @param params
     */
    openDetailDiga(article) {
        this.router.navigate(['/me/article/' + article.slug]);
    }
}
